// LogoSection.jsx
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { WELCOME_PATH } from '../../../config';
import Logo from '../../../components/Logo';

export default function LogoSection({ isMini = false }) {
  return (
    <Link
      component={RouterLink}
      to={WELCOME_PATH}
      aria-label="theme-logo"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        width: '100%',
        height: '100%'
      }}
    >
      <Logo isMini={isMini} />
    </Link>
  );
}